// This file needs to be used in the pure node code in gatsby-node as well
// therefore we have a limited subset of ES6 we can rely on
/* eslint-disable flowtype/require-valid-file-annotation */

// https://github.com/regexhq/word-regex/blob/master/index.js
// I'm not importing a bunch of MIT libraries just for this regex...
// Also it's modified to make the japanese detection a bit more sensible for our case
// as the Japanese in this doesn't need to be exact this is a pretty rough estimation
// https://gist.github.com/terrancesnyder/1345094
const wordRegex = /[a-zA-Z0-9_'\u0392-\u03c9\u0400-\u04FF\u0027]+|[ァ-ンー]+|[一-龯ー][一-龯ぁ-ん]*?([はがでのにをもへとやねよ]|ので|から|まで)|[ぁ-んー]+|[\u4E00-\u9FFF\u3400-\u4dbf\uf900-\ufaff\u3040-\u309f\uac00-\ud7af\u0400-\u04FF]+|[\u00E4\u00C4\u00E5\u00C5\u00F6\u00D6]+|[\u0531-\u0556\u0561-\u0586\u0559\u055A\u055B]+|\w+/g;
// this should only detect CLOSING punctuation, hence why 「 is not included
const punctuationRegex = /([^ァ-ン]ー|[。、〜」）/／・]|[,.!?\\-])$/gi;
function splitWords(string) {
  if (!string) return [];
  const newRegex = new RegExp(wordRegex.source, 'g');
  const result = [];
  while (newRegex.exec(string)) {
    const currentMatchedString = string.substring(
      result.length ? result[result.length - 1] : 0,
      newRegex.lastIndex
    );
    const punctuationMatch = string
      .substring(newRegex.lastIndex - 2, newRegex.lastIndex)
      .match(punctuationRegex);
    const lonelyHiraganaMatch =
      currentMatchedString !== 'お' &&
      currentMatchedString.match(/^[ぁ-んー]$/gi);
    if (punctuationMatch || lonelyHiraganaMatch) {
      result[result.length - 1] = newRegex.lastIndex;
    } else {
      const testMatch = string
        .substring(newRegex.lastIndex, newRegex.lastIndex + 4)
        .match(
          /^(ので|から|まで|[はがでのにをもへとやねよ]|)([。、〜ー」）/／・]|[,.!?\\-]|)/gi
        );
      const preventionMatch = string
        .substring(newRegex.lastIndex - 1, newRegex.lastIndex)
        .match(/[はがでのにをもへとやねよ]/);
      let endIndex = newRegex.lastIndex;
      if (
        testMatch &&
        (testMatch[0].match(punctuationRegex) ||
          !preventionMatch ||
          endIndex + testMatch[0].length === string.length)
      ) {
        endIndex += testMatch[0].length;
      }
      if (!result.length || endIndex > result[result.length - 1]) {
        if (
          result.length &&
          string.substring(
            result[result.length - 1] - 1,
            result[result.length - 1]
          ) === 'お'
        ) {
          result[result.length - 1] = endIndex;
        } else {
          result.push(endIndex);
        }
      }
    }
  }
  return result.map((stringIndex, arrayIndex) =>
    arrayIndex === 0
      ? string.substring(0, stringIndex)
      : string.substring(result[arrayIndex - 1], stringIndex)
  );
}

module.exports = {
  splitWords,
  wordRegex
};
